var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", [_vm._v("\n    " + _vm._s(_vm.index + 1) + "    \n  ")]),
    _vm._v(" "),
    _c("td", { attrs: { width: "80%" } }, [
      _c("div", { staticClass: "form-field select2" }, [
        _c(
          "div",
          { staticClass: "select2-field" },
          [
            _c("v-select", {
              attrs: {
                id: "item_" + _vm.index,
                options: _vm.items,
                tooltip:
                  _vm.selectedItem != null ? _vm.selectedItem.nombre : "",
                placeholder: "Seleccione...",
                label: "nombre"
              },
              on: { search: _vm.onSearchItem, input: _vm.inputItem },
              model: {
                value: _vm.selectedItem,
                callback: function($$v) {
                  _vm.selectedItem = $$v
                },
                expression: "selectedItem"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("td", [
      _c(
        "div",
        { staticClass: "form-field" },
        [
          _c("input-field", {
            directives: [
              {
                name: "mask",
                rawName: "v-mask",
                value: "##",
                expression: "'##'"
              }
            ],
            attrs: {
              type: "tel",
              id: "cantidad" + _vm.index,
              placeholder: "Escriba la cantidad..."
            },
            model: {
              value: _vm.modelValue.cantidad,
              callback: function($$v) {
                _vm.$set(_vm.modelValue, "cantidad", $$v)
              },
              expression: "modelValue.cantidad"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("td", [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: { click: _vm.eliminar }
        },
        [_c("i", { staticClass: "fa fa-trash" })]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-272eb6ae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-272eb6ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/TrEgresoBodega.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-272eb6ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/TrEgresoBodega.vue
// module chunks = 0